import template from './activities-list.html'

export let activitiesList = {
	bindings: {
		activities     : '<',
		filtering      : '<',
		onClick        : '&',
		notShowCheckbox: '<',
	},
	template    : template,
	controllerAs: 'vm',
	controller  : [ '$rootScope', '$cookies', '$stateParams', 'WorkPlanSrv', 'CssClasses', 'Validations', '$scope',
		function activitiesListCtrl ($rootScope, $cookies, $stateParams, WorkPlanSrv, CssClasses, Validations, $scope) {
			const backgroundColor = CssClasses.backgroundColor
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			const inExecution = Validations.inExecution(currentStage)
			const inEvaluation = Validations.inEvaluation(currentStage)
			const inReviewExecution = Validations.inReviewExecution(currentStage)
			const inReview = Validations.inReview(currentStage)
			const inApproval = Validations.inApproval(currentStage)
			const showIcons = () => inExecution || inReview || inApproval || inEvaluation || this.inHistory || inReviewExecution
			const showIconsMedal = () => inExecution || inEvaluation || this.inHistory || inReviewExecution || inReview

			angular.extend(this, {
				inHistory       : $stateParams.inHistory,
				background      : '',
				selectedActivity: {},
				selectActivity  : selectActivity,
				setBackground   : setBackground,
				isForPlanning   : true,
				showCheckbox    : (activity) => {
					return inExecution && Validations.isSubjectType(activity) && activity.origin === 3
				},
				disableActivity : (activity) => Boolean(activity.isForPlan),
				showIcons,
				showIconsMedal,
				updateIsPlanning: updateIsPlanning,
			})

			this.$onChanges = () => {
				this.selectedActivity = this.activities ? this.activities[0] : null

				if (this.selectedActivity) {
					for (let activity in this.activities) {
						setBackground(this.activities[activity], this.selectedActivity)
					}
				}
			}

			function setBackground (activity, selected) {
				if (activity.isExecution !== 1 && typeof activity.executionFinish !== 'undefined' && activity.executionFinish === 1) {
					activity.background = backgroundColor.inactivo
				}

				if (activity === selected) {
					activity.background = backgroundColor.purple
				} else {
					activity.background = ''
				}
			}

			function selectActivity (activity, index) {
				if ($rootScope.setHandsProgress)
					return

				if (activity.isExecution !== 1 && typeof activity.executionFinish !== 'undefined' && activity.executionFinish === 1) {
					return
				}

				this.onClick({ activity, index })
				this.setBackground(this.selectedActivity, activity)
				this.selectedActivity = activity
				this.setBackground(activity, activity)
			}

			$scope.$on('selectActivityEmit', selectActivityEmit)

			function selectActivityEmit ($event, activity) {
				$scope.vm.onClick({ activity: activity })
				$scope.vm.selectedActivity = activity
			}

			function updateIsPlanning (assignature) {
				return WorkPlanSrv.updateAssignatureWorkPlan.post({
					teacherId    : JSON.parse($cookies.get('currentUser')).teacherId,
					assignatureId: assignature.asignatureId,
					isPlanning   : assignature.isForPlanning,
				}).$promise.then((dataReturn) => {
					// console.log(dataReturn)
					return dataReturn
				})
			}
		},
	] }


// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activities-list.js